import React from "react";

import InputExtra from "@components/Form/InputExtra";
import { TYPE_STRING, TYPE_TEXT } from "@components/Form";

const PUBLIC_KEY_ROWS = 8;

const EXTRA_NAME = "Give a name that tells you which of your clients uses this key.";
const EXTRA_ISSUER = "Give the iss claim of your client. Each ID token of this key must carry the same value.";
const EXTRA_PUBLIC_KEY = "Paste the public key of your client in PEM format. Keep the BEGIN PUBLIC KEY and the END PUBLIC KEY markers.";

type CreateInput = {
  name: "name" | "issuer" | "publicKey";
  type: typeof TYPE_STRING | typeof TYPE_TEXT;
  itemProps: {
    extra: JSX.Element;
  };
  inputProps?: {
    rows: number;
  };
};

const getCreateInputs = (): CreateInput[] => {
  return [
    {
      name: "name",
      type: TYPE_STRING,
      itemProps: {
        extra: <InputExtra text={EXTRA_NAME} />,
      },
    },
    {
      name: "issuer",
      type: TYPE_STRING,
      itemProps: {
        extra: <InputExtra text={EXTRA_ISSUER} />,
      },
    },
    {
      name: "publicKey",
      type: TYPE_TEXT,
      itemProps: {
        extra: <InputExtra text={EXTRA_PUBLIC_KEY} />,
      },
      inputProps: {
        rows: PUBLIC_KEY_ROWS,
      },
    },
  ];
};

export default getCreateInputs;
